// extracted by mini-css-extract-plugin
export var button = "stacked-3-0-ebook-module--button--f599b";
export var content = "stacked-3-0-ebook-module--content--edcf0";
export var description = "stacked-3-0-ebook-module--description--c9121";
export var divider = "stacked-3-0-ebook-module--divider--5fdd2";
export var dtcStackSection = "stacked-3-0-ebook-module--dtcStackSection--9015b";
export var ebook = "stacked-3-0-ebook-module--ebook--66aa8";
export var foldSection = "stacked-3-0-ebook-module--foldSection--3fea9";
export var form = "stacked-3-0-ebook-module--form--fd574";
export var formSection = "stacked-3-0-ebook-module--formSection--6c704";
export var overlay = "stacked-3-0-ebook-module--overlay--f4b94";
export var partnerSection = "stacked-3-0-ebook-module--partnerSection--a81b2";
export var partners = "stacked-3-0-ebook-module--partners--d9e83";
export var tag = "stacked-3-0-ebook-module--tag--e6326";
export var title = "stacked-3-0-ebook-module--title--a5858";